<template>
  <el-col :span="spanColumn">
    <div class="label">{{ props.label }}</div>
    <div
      class="data"
      :style="{ 'line-height': lineHeight }"
    >
      {{ displayData }}
    </div>
  </el-col>
</template>

<script setup>
import { computed } from 'vue';
import { formatNumberLocale } from '@/shared/utils/locale_number_utils.js';

const props = defineProps({
  spanColumn: Number,
  label: [String, Number],
  data: [String, Number],
  formatNumber: {
    type: Boolean,
    default: false,
  },
  precision: {
    type: Number,
    default: undefined,
  },
  space: {
    type: String,
    default: 'input',
    validator: (value) => {
      return ['input', 'shrink'].includes(value);
    },
  },
});

const lineHeight = computed(() => {
  return props.space === 'input' ? '1.55rem' : '1';
});

const displayData = computed(() => {
  if (props.formatNumber) {
    const num = Number(props.data);
    if (!isNaN(num)) {
      return formatNumberLocale(num, props.precision);
    }
  }
  return props.data;
});
</script>

<style scoped>
.label {
  font-weight: 700;
  color: #111;
}
.data {
  line-height: 2.3;
}
</style>
